import Apis from '@/Apis/_'
import { EmailMensagemQuery } from '@/types/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class Notificacoes extends CoreBase implements INotificacoes {
  async getEmailsRecebidos(param: EmailMensagemQuery): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getEmailsRecebidos(param)
    return response
  }

  async backofficeResolveEmail(id: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeResolveEmail(id)
    return response
  }
}

interface INotificacoes extends ICoreBase {
  getEmailsRecebidos(param: EmailMensagemQuery): Promise<ResponseApi>
  backofficeResolveEmail(id: string): Promise<ResponseApi>
}

export {
  Notificacoes,
  INotificacoes,
}
